module.exports = __webpack_public_path__ + "img/demaekan_btn.d2bf3810.png";